import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-code-block.tsx
var LazyCodeBlock = lazy(() => import("./code-block-BZu1b4y_.js").then((n) => n.n).then((module) => ({ default: module.CodeBlock })));
function CodeBlock({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "code-block" }),
		children: /* @__PURE__ */ jsx(LazyCodeBlock, { ...props })
	});
}
function CodeBlockContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "code-block" }),
		children: /* @__PURE__ */ jsx(LazyCodeBlock, { ...props })
	});
}
var useCodeBlockContent = () => {
	return useMemo(() => ({ codeBlock: { component: CodeBlockContent } }), []);
};
//#endregion
export { CodeBlock, useCodeBlockContent };
